module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/099-albania-e5e2f1f6d297d53ce2e828be4ae7ca2a.svg";